// extracted by mini-css-extract-plugin
export default {"holid-ad":"holid-ad--2okPh","holidAd":"holid-ad--2okPh","holid-ad-loaded":"holid-ad-loaded--GKn8Y","holidAdLoaded":"holid-ad-loaded--GKn8Y"};